/**
 * BondTypeConfigsPage — Brief 4 (Gestor) · Tela 9 Configuração de Bonds
 * (ADR-037/131 · overlay por-tenant do catálogo canônico de 21 tipos).
 *
 * Rota: /admin/atendimento/bonds. Leitura + toggle sobre /v1/bond-type-configs.
 * Padrão D-B (defense-in-depth): gate próprio na página (`bond-type-config-read`),
 * além da query gateada no hook — não confia só na rota/nav. O toggle é gateado
 * em `bond-type-config-manage` dentro da view (sem ele, leitura).
 *
 * ATENÇÃO: NÃO confundir com a feature `bonds/` (instâncias de Bond no TabCliente
 * da conversa). Esta tela configura QUAIS TIPOS a operação usa, não Bonds.
 */

import { CapabilityLockedBanner } from '@lume/ui-components';

import { BondTypeConfigsView } from '../features/bond-type-configs/BondTypeConfigsView';
import { useBondTypeConfigList } from '../features/bond-type-configs/use-bond-type-configs';
import { useCapability } from '../hooks/use-capability';

import '../features/bond-type-configs/bond-type-configs.css';

export function BondTypeConfigsPage(): JSX.Element {
  const canRead = useCapability('bond-type-config-read');

  // D-B — gate próprio, não confiar só na rota protegida.
  if (!canRead) {
    return (
      <div className="bond-type-configs-screen bond-type-configs-screen--gate">
        <CapabilityLockedBanner
          capability="bond-type-config-read"
          tierMin="solo"
          fallbackMessage="A configuração de tipos de vínculo é restrita a perfis com acesso às configurações do tenant."
        />
      </div>
    );
  }

  return <BondTypeConfigsPageInner />;
}

function BondTypeConfigsPageInner(): JSX.Element {
  const canManage = useCapability('bond-type-config-manage');
  const list = useBondTypeConfigList();

  if (list.isLoading) {
    return (
      <div className="bond-type-configs-screen">
        <div className="btc-page">
          <p className="btc-muted">Carregando tipos de Bond…</p>
        </div>
      </div>
    );
  }

  if (list.isError) {
    return (
      <div className="bond-type-configs-screen">
        <div className="btc-page">
          <p className="btc-banner btc-banner--muted" role="alert">
            Falha ao carregar os tipos de Bond.
          </p>
        </div>
      </div>
    );
  }

  return <BondTypeConfigsView configs={list.data} canManage={canManage} />;
}
